import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import { StatisticEvent } from '../_models/statisticevent';
import { Dashboard } from '../_models/dashboard';
import { AuthenticationService } from '../_services/authentication.service';
import { EnvironmentService } from './index';


@Injectable()
export class StatisticsService {
  private baseUrl: string = this.environmentService.getBaseURL() + '/api';

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService) {
  }

  getDashboard(): Observable<Dashboard>{
  // new change - get dealer id from localstorage and pass dealer id in api
    var currentUser  = JSON.parse(localStorage.getItem('currentUser'));
    let dashboard$ = this.http
      .get(`${this.baseUrl}/dashboard/`+currentUser._id, this.makeHeaders())
      .map(mapDashboard)
      .catch(handleError);
    return dashboard$;
  }

  sendEvent(statisticEvent : StatisticEvent) : Observable<StatisticEvent>{
    statisticEvent.createdAt = new Date();
    let newstatistic = this.http
      .post(`${this.baseUrl}/statisticevents`, JSON.stringify(statisticEvent), this.makeHeaders())
      .map(mapStatisticEvent);
    return newstatistic;
  }

  private makeHeaders():RequestOptions {
    let headers = new Headers();

    headers.append('Authorization', this.authenticationService.getToken());
    headers.append('Content-Type', 'application/json ');
    headers.append('charset', 'UTF-8 ');
    headers.append('Accept', 'application/json ');

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}

function toStatisticEvent(r: any): StatisticEvent{
  let statisticEvent = <StatisticEvent>({
    _id: r._id,
    customer: r.customer,
    event: r.event,
    createdAt: r.createdAt
  });
  return statisticEvent;
}

function toDashboard(r: any): Dashboard{
  let dashboard = <Dashboard>({
      landingpage_visit: r.landingpage_visit,
			landingpage_calculator: r.landingpage_calculator,
      checkout_complete: r.checkout_complete,
      dealer_landingpage_visit: r.dealer_landingpage_visit,
      dealer_landingpage_calculator: r.dealer_landingpage_calculator,
      dealer_checkout_complete: r.dealer_checkout_complete
  });
  return dashboard;
}

function mapStatisticEvent(response:Response): StatisticEvent{
  // toPerson looks just like in the previous example
  return toStatisticEvent(response.json());
}
function mapDashboard(response:Response): Dashboard{
  // toPerson looks just like in the previous example
  return toDashboard(response.json());
}

// this could also be a private method of the component class
function handleError (error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/statistics.service.ts